import axios from 'axios';

export const getNetworks = async (apiUrl, region, queryParams) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (queryParams) {
    return axios.get(`${apiUrl}/v2.0/networks${queryParams}`, settings);
  } else {
    return axios.get(`${apiUrl}/v2.0/networks`, settings);
  }
}

export const getNetworkDetails = async (apiUrl, networkId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/v2.0/networks/${networkId}`, settings);
}

export const createNetwork = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/v2.0/networks`, data, settings);
}

export const deleteNetwork = async (apiUrl, networkId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/v2.0/networks/${networkId}`, settings);
}

export const updateNetwork = async (apiUrl, networkId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.put(`${apiUrl}/v2.0/networks/${networkId}`, data, settings);
}

export const getNetworkQuota = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  let projectId = JSON.parse(localStorage.getItem('current_project'))[region];

  if (projectId == undefined) {
      if (region === 'core') {
          projectId = JSON.parse(localStorage.getItem('current_project')).ams2;
      } else if (region === 'stagingamstwo') {
          projectId = JSON.parse(localStorage.getItem('current_project')).staging102;
      } else if (region === 'stagingamsthree') {
          projectId = JSON.parse(localStorage.getItem('current_project')).staging101;
      }
  }
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/v2.0/quotas/${projectId}/details.json`, settings);
}

// ROUTERS
export const getRouters = async (apiUrl, region, queryParams, networkId) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (networkId) {
    return axios.get(`${apiUrl}/v2.0/routers?network_id=${networkId}`, settings);
  } else if (queryParams) {
    return axios.get(`${apiUrl}/v2.0/routers${queryParams}`, settings);
  } else {
    return axios.get(`${apiUrl}/v2.0/routers/`, settings);
  }
}

export const getRouter = async (apiUrl, region, routerId) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };
  
  return axios.get(`${apiUrl}/v2.0/routers/${routerId}`, settings);
}

export const createRouter = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/v2.0/routers`, data, settings);
}

export const deleteRouter = async (apiUrl, routerId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/v2.0/routers/${routerId}`, settings);
}

export const updateRouter = async (apiUrl, routerId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.put(`${apiUrl}/v2.0/routers/${routerId}`, data, settings);
}

export const addInterfaceRouter = async (apiUrl, routerId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.put(`${apiUrl}/v2.0/routers/${routerId}/add_router_interface`, data, settings);
}

export const detachInterfaceRouter = async (apiUrl, routerId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.put(`${apiUrl}/v2.0/routers/${routerId}/remove_router_interface`, data, settings);
}

// SUBNETS
export const getSubnets = async (apiUrl, region, networkId, queryParams) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (networkId) {
    return axios.get(`${apiUrl}/v2.0/subnets?network_id=${networkId}`, settings);
  } else if (queryParams) {
    return axios.get(`${apiUrl}/v2.0/subnets${queryParams}`, settings);
  } else {
    return axios.get(`${apiUrl}/v2.0/subnets`, settings);
  }
}

export const createSubnet = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/v2.0/subnets`, data, settings);
}

export const getSubnetDetails = async (apiUrl, region, subnetId) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/v2.0/subnets/${subnetId}`, settings);
}

export const updateSubnet = async (apiUrl, region, subnetId, data) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.put(`${apiUrl}/v2.0/subnets/${subnetId}`, data, settings);
}

export const deleteSubnet = async (apiUrl, subnetId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/v2.0/subnets/${subnetId}`, settings);
}

// PORTS
export const getPorts = async (apiUrl, region, queryParams, deviceId, networkId, deviceOwner, subnetId) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (deviceId) {
    return axios.get(`${apiUrl}/v2.0/ports?device_id=${deviceId}`, settings);
  } else if (networkId) {
    return axios.get(`${apiUrl}/v2.0/ports?network_id=${networkId}`, settings);
  } else if (deviceOwner) {
    if (deviceOwner === 'compute') {
        if (region === 'fra') {
            deviceOwner = 'compute:fra-a&device_owner=compute:fra-b&device_owner=compute:fra-c';
        } else {
            deviceOwner = 'compute:ams2-a&device_owner=compute:ams2-b&device_owner=compute:ams2-c';
        }
        return axios.get(`${apiUrl}/v2.0/ports?device_owner=${deviceOwner}`, settings);
    } else {
        return axios.get(`${apiUrl}/v2.0/ports?device_owner=${deviceOwner}`, settings);
    }
  } else if (subnetId) {
    return axios.get(`${apiUrl}/v2.0/ports?fixed_ips=subnet_id=${subnetId}`, settings);
  } else if (queryParams) {
    return axios.get(`${apiUrl}/v2.0/ports${queryParams}`, settings);
  } else {
    return axios.get(`${apiUrl}/v2.0/ports/`, settings);
  }
}

export const getPortDetails = async (apiUrl, region, portId) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/v2.0/ports/${portId}`, settings);
}

export const createPort = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/v2.0/ports`, data, settings);
}

export const deletePort = async (apiUrl, portId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/v2.0/ports/${portId}`, settings);
}

export const updatePort = async (apiUrl, portId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.put(`${apiUrl}/v2.0/ports/${portId}`, data, settings);
}

// IPS
export const getIps = async (apiUrl, region, extraParams) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (extraParams) {
    return axios.get(`${apiUrl}/v2.0/floatingips${extraParams}`, settings);
  } else {
    return axios.get(`${apiUrl}/v2.0/floatingips`, settings);
  }
}

export const createIp = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/v2.0/floatingips`, data, settings);
}

export const associateIp = async (apiUrl, ipId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.put(`${apiUrl}/v2.0/floatingips/${ipId}`, data, settings);
}

export const deleteIp = async (apiUrl, ipId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/v2.0/floatingips/${ipId}`, settings);
}

// SECURITY GROUPS
export const getSecurityGroups = async (apiUrl, region, queryParams, id) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (id) {
    return axios.get(`${apiUrl}/v2.0/security-groups/${id}`, settings);
  } else {
    return axios.get(`${apiUrl}/v2.0/security-groups`, settings);
  }
}

export const createSecurityGroup = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/v2.0/security-groups`, data, settings);
}

export const deleteSecurityGroup = async (apiUrl, id, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/v2.0/security-groups/${id}`, settings);
}

export const createSecurityGroupRule = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/v2.0/security-group-rules`, data, settings);
}

export const deleteSecurityGroupRule = async (apiUrl, id, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/v2.0/security-group-rules/${id}`, settings);
}
